export const ENV = process.env.NODE_ENV
export const SENTRY_ENV = process.env.SENTRY_ENV

const DOMAIN = process.env.API_DOMAIN

/*// export const API_DOMAIN = `https://api-qa.${DOMAIN}/`
// export const API_DOMAIN = `https://api.${DOMAIN}/`
//export const API_DOMAIN = `http://api.advenio.net:8081/`*/

export const API_DOMAIN = SENTRY_ENV !== 'production' ? `https://api-qa.${DOMAIN}/` : `https://api.${DOMAIN}/`

export const SENTRY_URL = '20c7de1beb1d4adc86c9eecefa1edf0f@sentry.talisis.com/4'

const HOST = ENV === 'development' ? 'localhost' : DOMAIN

export const COOKIE_DOMAIN = HOST
export const PLATFORMS_LINKS = HOST
export const TENANT = process.env.TENANTID
export const AUTH365_CLIENT = process.env.AUTH365_CLIENT_ID
export const PORT = process.env.PORT


export const getUrl = (platform) => {
    if (ENV === 'development') {
        if (platform.toLowerCase() === 'miadvenio') {
            return 'qa'
        }
        return platform + '-qa'
    }

    let subdomain = platform
    if (SENTRY_ENV !== 'production') {
        if (platform.toLowerCase() === 'miadvenio') {
            subdomain = 'qa'
        } else {
            subdomain + '-qa'
        }

    } else {
        subdomain = 'app'

    }
    return `https://${subdomain}.${DOMAIN}`
}

export const getPlatformLink = (platform) => {
    if (platform === 'miadvenio') {
        return PLATFORMS_LINKS === 'localhost' ? `http://${PLATFORMS_LINKS}:8080` : SENTRY_ENV !== 'production' ? `https://qa.${PLATFORMS_LINKS}` : `https://app.${PLATFORMS_LINKS}`
    }
    if (platform === 'hr') {
        return PLATFORMS_LINKS === 'localhost' ? `http://${PLATFORMS_LINKS}:8080` : SENTRY_ENV !== 'production' ? `https://rh-qa.${PLATFORMS_LINKS}` : `https://rh.${PLATFORMS_LINKS}`
    }
    if (platform === 'companies' && SENTRY_ENV !== 'production') {
        return PLATFORMS_LINKS === 'localhost' ? `http://${PLATFORMS_LINKS}:8080` : `https://empresas-dev.${PLATFORMS_LINKS}`
    }

    return PLATFORMS_LINKS === 'localhost' ? `http://${PLATFORMS_LINKS}:8080` : SENTRY_ENV !== 'production' ? `https://${platform}-qa.${PLATFORMS_LINKS}` : `https://${platform}.${PLATFORMS_LINKS}`
}



// WEBPACK FOOTER //
// ./src/config.js